import type { Components, Theme } from "@mui/material";

export const tableRowTheme: Components<Theme>["MuiTableRow"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& td:first-of-type": {
        paddingLeft: theme.spacing(3),
      },
      "& td:last-of-type": {
        paddingRight: theme.spacing(3),
      },
      "& th:first-of-type": {
        paddingLeft: theme.spacing(3),
      },
      "& th:last-of-type": {
        paddingRight: theme.spacing(3),
      },
    }),
  },
};
